// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_azure_msal-browser_dist_controllers_NestedAppAuthController_mjs":"56c95e9f40bfe3eb","node_modules_html2canvas_dist_html2canvas_js":"cb18f85e422d0b3f","node_modules_dompurify_dist_purify_js":"7ca6217403d24e39","node_modules_canvg_lib_index_es_js":"3a79dc929f64d13a"}[chunkId] + ".js";
};